import type { Lot } from '../../types/lot'
import { get } from 'svelte/store'
import {
	closeFAKCallback,
	defaultCatalogOptions,
	defaultMaterialOptions,
	formErrors,
	mapFormControls
} from './fakStores'
import { getUserAccountAutocompleteText, type UserAccountData } from '$types/userAccountData'
import { getMaterialCatalogsAndMaterialOptions } from '$utils/material'

export function adjustMargin(currentLot: Lot | null, scrollDetailsLayerToTop: boolean = false) {
	const projectFormContainer = document.getElementById('project-form-container')
	const projectLayer = document.getElementById('fak-project-layer')
	const projectAccordion = document.getElementById('project-accordion')
	if (projectFormContainer && projectLayer && projectAccordion) {
		const projectLayerMarginNumber =
			Math.abs(projectLayer.offsetHeight - projectFormContainer.offsetHeight) / 2
		const projectLayerMargin = projectLayerMarginNumber + 'px'
		projectAccordion.style.marginTop = projectLayerMargin
		projectAccordion.style.marginBottom = projectLayerMargin
		const lotsAccordionList = document.getElementById('lots-accordion-list')
		if (lotsAccordionList) {
			lotsAccordionList.style.marginTop = projectLayerMargin

			setTimeout(() => {
				//scrollLotDetailsLayer = false;
				const lotsLayer = document.getElementById('fak-lots-accordion')
				let lotsLayerOffset = 0
				if (currentLot && currentLot.id !== 'new') {
					const selectedLot = document.getElementById('lot-' + currentLot.id)
					if (selectedLot) {
						lotsLayerOffset = selectedLot.offsetTop - projectLayerMarginNumber
						lotsAccordionList.style.marginBottom =
							window.innerHeight - projectLayerMarginNumber - 161 + 'px'
					}
				} else {
					lotsAccordionList.style.marginBottom = projectLayerMargin
				}

				function scrollToLotsDetailsTop() {
					const lotDetailsLayer = document.getElementById('fak-lot-details-layer')
					if (lotsLayer && lotDetailsLayer) {
						lotDetailsLayer.scrollTo({
							top: lotsLayer.scrollTop - lotsLayerOffset,
							behavior: 'smooth'
						})
					}
				}

				if (lotsLayer) {
					if (scrollDetailsLayerToTop) {
						if (lotsLayerOffset === 0) {
							scrollToLotsDetailsTop()
						} else {
							lotsLayer.addEventListener(
								'scrollend',
								() => {
									scrollToLotsDetailsTop()
								},
								{ once: true }
							)
						}
					}
					lotsLayer.scrollTo({ top: lotsLayerOffset, behavior: 'smooth' })
				}
			}, 300)
		}
		const lotDetailsAccordion = document.getElementById('lot-details-accordion')
		if (lotDetailsAccordion) {
			lotDetailsAccordion.style.marginTop = projectLayerMargin
			lotDetailsAccordion.style.marginBottom = projectLayerMargin
		}
	}
}

export function clearFormErrors() {
	formErrors.set([{ path: '', message: '' }])
}

export function closeFAK() {
	setFAKLevel(0)
	// FIXME: Hack for /maplibre: if maplibre sets a modal callback, invoke it to close FaK
	const callback = get(closeFAKCallback)
	if (callback) {
		callback()
	}
}

function setFAKLevel(newLevel: number) {
	mapFormControls.update((c) => {
		c.level = newLevel
		return c
	})
}

export function loadDefaultCatalogAndMaterialOptions() {
	getMaterialCatalogsAndMaterialOptions()
		.then((data) => {
			defaultCatalogOptions.set(data.catalogDefaults)
			defaultMaterialOptions.set(data.materialDefaultsMap)
		})
		.catch(console.error)
}

export function getUserAccountAcOptions(key: UserAccountData) {
	let options: { text: string; id: number | null; firstName: string; lastName: string }[]
	if (key && key.id) {
		options = [key].map((op) => {
			return {
				...op,
				text: getUserAccountAutocompleteText(op)
			}
		})
	} else {
		options = []
	}
	return options
}
